import apiService from '@/api/apiService';

export const updateUserDetailVersion = async (id, payload) => {
    const url = `/api/admin/user-detail-version/${id}`;
    return apiService.PUT(url, payload);
};